<template>
    <div>
        <Crumbs></Crumbs>
        <div class="mainList">
            <div class="mainList_operation clearfloat">
                <div class="fr">
                    <el-button type="primary" icon="el-icon-plus" @click="add">新增</el-button>
                </div>
            </div>
            <div class="mainList_content">
                <div class="mainList_content_sub">
                    <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" height="string" v-loading="loading">
                        <el-table-column label="序号" type="index" align="center" width="70"></el-table-column>
                        <el-table-column align="center" prop="name" label="名称"></el-table-column>
                        <el-table-column prop="description" align="center" label="描述"></el-table-column>
                        <el-table-column prop="status" align="center" label="状态">
                            <template slot-scope="scope">
                                {{  scope.row.status | status  }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="120">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="edit(scope)">编辑</el-button>
                                <el-button type="text" size="small" @click="roleAuthorization(scope.row)">授权</el-button>
                                <el-button type="text" size="small" class="danger" @click="del(scope)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <Edit :isShow.sync="showEditDialog" :options="options"></Edit>
        <RoleAuthorization :isShow.sync="showRoleAuthorization" :options="options"></RoleAuthorization>
    </div>
</template>
<script>


export default {
    components: {
        Edit: () => import("./Edit.vue"),
        RoleAuthorization: () => import("./RoleAuthorization.vue"),
        Crumbs: () => import("@/components/Crumbs.vue"),
    },
    data() {
        return {
            parameter:{
                method:'get.auth.group.list',
                page_no:1,
                page_size:50,
                total_result:0,
            },
            options: {},
            tableData: [],
            loading: false,
            showEditDialog: false,
            showRoleAuthorization:false,
        };
    },
    provide () {
        return {
            refresh:this.refresh,
        }
    },
    watch: {},
    created() {
        this.getData();

    },
    methods: {
        refresh(){
            this.showEditDialog = false;
            this.showRoleAuthorization = false;
            this.pageChangeHandler(1);
        },
        edit(scope) {
            this.options = scope.row;
            this.showEditDialog = true

        },
        add() {
            this.options = {};
            this.showEditDialog = true

        },
        roleAuthorization(row) {
            this.options = row;
            this.showRoleAuthorization = true;
        },
        getData() {
            this.loading = true;
            this.$api.role.auth_group(this.parameter).then(res => {
                this.loading = false;
                this.tableData = res.data;
            }).catch(err => {
                console.log(err);
                this.loading = false;
            });
        },
        del(scope) {
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$api.role.auth_group({
                    module:'admin',
                    method:'del.auth.group.list',
                    'group_id':scope.row.group_id,
                }).then(res => {

                    this.$message.success("删除成功！");

                    var hasLastPage = this.parameter.page_size*this.parameter.page_no>=this.parameter.total_result;
                    var lastData = this.tableData.length<2;
                    if (lastData&&hasLastPage&&this.parameter.page_no>1) {
                        this.parameter.page_no --;
                    };
                    this.getData();


                }).catch(err => {
                    console.log(err);
                });
            }).catch(() => {//用户取消

            });
        },
    },
};
</script>
<style scoped lang='scss'>
@import "@/styles/config.scss";

</style>
